import { defineStore } from 'pinia';
import { ref } from 'vue';
import { LogsActionsServiceName } from '@/common/constants';

export interface LogsActionsDrawerContext {
  serviceName: LogsActionsServiceName;
  initialUsername?: string;
  initialFullname?: string;
  initialFrom?: string;
  initialTo?: string;
  initialMinStatusCode?: number | null;
  initialMaxStatusCode?: number | null;
  initialTop?: number;
}

const DEFAULT_TOP = 100;

export const useLogsActionsDrawerStore = defineStore('logsActionsDrawer', () => {
  const isOpen = ref(false);
  const serviceName = ref<LogsActionsServiceName>(LogsActionsServiceName.MsOutgoing);
  const initialUsername = ref('');
  const initialFullname = ref('');
  const initialFrom = ref('');
  const initialTo = ref('');
  const initialMinStatusCode = ref<number | null>(null);
  const initialMaxStatusCode = ref<number | null>(null);
  const initialTop = ref(DEFAULT_TOP);

  const resetContext = () => {
    serviceName.value = LogsActionsServiceName.MsOutgoing;
    initialUsername.value = '';
    initialFullname.value = '';
    initialFrom.value = '';
    initialTo.value = '';
    initialMinStatusCode.value = null;
    initialMaxStatusCode.value = null;
    initialTop.value = DEFAULT_TOP;
  };

  const open = (context: LogsActionsDrawerContext) => {
    serviceName.value = context.serviceName;
    initialUsername.value = context.initialUsername ?? '';
    initialFullname.value = context.initialFullname ?? '';
    initialFrom.value = context.initialFrom ?? '';
    initialTo.value = context.initialTo ?? '';
    initialMinStatusCode.value = context.initialMinStatusCode ?? null;
    initialMaxStatusCode.value = context.initialMaxStatusCode ?? null;
    initialTop.value = context.initialTop ?? DEFAULT_TOP;
    isOpen.value = true;
  };

  const close = () => {
    isOpen.value = false;
  };

  const closeAndReset = () => {
    close();
    resetContext();
  };

  return {
    isOpen,
    serviceName,
    initialUsername,
    initialFullname,
    initialFrom,
    initialTo,
    initialMinStatusCode,
    initialMaxStatusCode,
    initialTop,
    open,
    close,
    closeAndReset,
    resetContext,
  };
});
